import auth from './client';

export { AuthContext } from './components/AuthRouter';
export { default as Authenticated } from './components/Authenticated';
export { default as HomeRoute } from './components/HomeRoute';
export { default as NotAuthenticated } from './components/NotAuthenticated';
export { default as AuthRouter } from './components/AuthRouter';
export { default as UserProfileForm } from './components/UserProfileForm';
export { useAuth, useAuthState } from './hooks/useAuth';
export type {
  AuthAccessTokenOptions,
  AuthAdapter,
  AuthContextValue,
  AuthImpersonationRequest,
  AuthLogoutOptions,
  AuthNotice,
  AuthProfileUpdatePayload,
  AuthStartLoginOptions,
  AuthState,
} from './types';

export function init(...args: Parameters<typeof auth.init>) {
  return auth.init(...args);
}

export default auth;
